import { makeRequest, CommonRequestOptions } from '../makeRequest';

export async function cancelQuizSession(quizid: number, { ...common }: CommonRequestOptions = {}) {
   return makeRequest('post', '/quizzes/sessions/cancel', {
      ...common,
      body: {
         quizid,
      },
   });
}
